import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { CalendarCheck, Store, Laptop } from "lucide-react";
import api from "../lib/api";

const DAYS = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];

// When and how the family shops — drives Millie's "list is ready / order now" nudge the evening before.
export default function ShopPrefs() {
  const [prefs, setPrefs] = useState(null);
  const [open, setOpen] = useState(false);
  useEffect(() => { api.get("/notifications/prefs").then((r) => setPrefs(r.data)).catch(() => {}); }, []);
  const save = async (next) => {
    setPrefs(next);
    try { await api.put("/notifications/prefs", next); } catch { toast.error("Couldn't save that"); }
  };
  if (!prefs) return null;
  const summary = prefs.shop_day
    ? `${prefs.shop_mode === "online" ? "Online order" : "In-store shop"} every ${prefs.shop_day} · Millie nudges you at ${prefs.shop_reminder_time} the night before`
    : "Tell Millie when you shop and she'll have next week's list ready in time";
  return (
    <div className="bg-white rounded-3xl border-2 border-[#FDECEF] p-4 shadow-soft" data-testid="shop-prefs">
      <button onClick={() => setOpen((v) => !v)} data-testid="shop-prefs-toggle" className="w-full flex items-center gap-3 text-left">
        <span className="w-10 h-10 rounded-2xl bg-[#DDEBE1] text-emerald-700 flex items-center justify-center"><CalendarCheck size={18} strokeWidth={2.5} /></span>
        <div className="flex-1 min-w-0">
          <p className="font-heading font-semibold text-sorted-ink leading-tight">Shop day</p>
          <p className="text-[11px] text-sorted-slate font-semibold" data-testid="shop-prefs-summary">{summary}</p>
        </div>
      </button>
      {open && (
        <div className="mt-3 space-y-3">
          <div className="flex gap-1.5 overflow-x-auto no-scrollbar">
            {DAYS.map((d) => (
              <button key={d} onClick={() => save({ ...prefs, shop_day: prefs.shop_day === d ? null : d })} data-testid={`shop-day-${d}`}
                className={`shrink-0 px-3 py-1.5 rounded-full text-xs font-bold border-2 ${prefs.shop_day === d ? "bg-sorted-ink border-sorted-ink text-white" : "bg-white border-[#FDECEF] text-sorted-slate"}`}>{d.slice(0, 3)}</button>
            ))}
          </div>
          <div className="flex gap-2">
            {[["instore", "In store", Store], ["online", "Online · pickup/delivery", Laptop]].map(([k, l, Icon]) => (
              <button key={k} onClick={() => save({ ...prefs, shop_mode: k })} data-testid={`shop-mode-${k}`}
                className={`flex-1 py-2.5 rounded-full text-xs font-bold border-2 flex items-center justify-center gap-1 ${prefs.shop_mode === k ? "bg-sorted-rose border-sorted-rose text-white" : "bg-white border-[#FDECEF] text-sorted-slate"}`}><Icon size={13} strokeWidth={2.5} /> {l}</button>
            ))}
          </div>
          <div className="flex items-center justify-between">
            <label className="text-xs font-bold text-sorted-slate">Nudge me the night before at</label>
            <input type="time" value={prefs.shop_reminder_time} onChange={(e) => save({ ...prefs, shop_reminder_time: e.target.value })} data-testid="shop-reminder-time"
              className="bg-[#FFF6F1] rounded-2xl px-3 py-2 text-sm font-bold text-sorted-ink outline-none" />
          </div>
          <p className="text-[11px] text-sorted-slate">{prefs.shop_mode === "online" ? "\"Your list's ready — order online now for pickup tomorrow.\"" : "\"Shop day tomorrow — have a squiz at the list tonight.\""}</p>
        </div>
      )}
    </div>
  );
}
